import { createWeb3Name } from '@web3-name-sdk/core';

export const web3Name = createWeb3Name({
  isDev: process.env.NEXT_PUBLIC_ENV_VARIABLE === 'development',
});
